export const FETCH_RECORD = 'FETCH_RECORD'
export const FETCH_RECORD_SUCCESS = 'FETCH_RECORD_SUCCESS'
export const FETCH_RECORD_FAILED = 'FETCH_RECORD_FAILED'

export const UPDATE_RECORD = 'UPDATE_RECORD'

export const DUPLICATE_RECORD = 'DUPLICATE_RECORD'
export const DUPLICATE_RECORD_SUCCESS = 'DUPLICATE_RECORD_SUCCESS'
export const DUPLICATE_RECORD_FAILED = 'DUPLICATE_RECORD_FAILED'

export const RESET_RECORD = 'RESET_RECORD'

export const DELETE_RECORD = 'DELETE_RECORD'
export const DELETE_RECORD_SUCCESS = 'DELETE_RECORD_SUCCESS'
export const DELETE_RECORD_FAILED = 'DELETE_RECORD_FAILED'
